import { env } from '@skin-seoul/env-utils';
import qs from 'qs';

import axios, { AxiosInstance } from 'axios';
import { attachRecaptchaInterceptor } from '../recaptcha';

const DEFAULT_BASE_URL = 'https://api.skin-seoul.com';

const getBaseURL = (): string => {
  return env('NEXT_PUBLIC_ENV_SERVER_ORIGIN') || DEFAULT_BASE_URL;
};

/**
 * you can use next cache with fetchOptions
 *
 * example:
 * const { data } = await client.get('/products', {
 *   fetchOptions: {
 *     next: {
 *       revalidate: 60,
 *     },
 *     cache: 'force-cache',
 *   },
 */

export const createSkinSeoulClient = (_baseURL?: string): AxiosInstance => {
  const initialBaseURL = _baseURL ?? getBaseURL();

  const isServer = typeof window === 'undefined';

  const instance = axios.create({
    baseURL: initialBaseURL,
    withCredentials: true,
    adapter: 'fetch',
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
  });

  // Fix for race condition: re-check baseURL on each request
  // This ensures correct URL even if window.__ENV was not available at module load time
  instance.interceptors.request.use((config) => {
    if (typeof window !== 'undefined') {
      const currentBaseURL = getBaseURL();
      const configBaseURL = config.baseURL || instance.defaults.baseURL;

      if (currentBaseURL !== DEFAULT_BASE_URL && configBaseURL !== currentBaseURL) {
        console.warn('[service/client] Race condition detected - fixing baseURL:', {
          from: configBaseURL,
          to: currentBaseURL,
        });
        config.baseURL = currentBaseURL;
        instance.defaults.baseURL = currentBaseURL;
      }
    }
    return config;
  });

  // reCAPTCHA interceptor (client-side only)
  if (!isServer) {
    attachRecaptchaInterceptor(instance);
  }

  return instance;
};

export let client: AxiosInstance = createSkinSeoulClient();

export const setClient = (instance: AxiosInstance) => {
  client = instance;
};
